import Vue from 'vue'
import { URL_LOTS } from '@/constants/urls.js'
import { LOT_MANAGEMENT, ERRORS, AXIOS_REQUESTS } from '@/constants/store.js'

const state = {
  [LOT_MANAGEMENT.STATE.CURRENT_LOT]: null
}

const actions = {
  async [LOT_MANAGEMENT.ACTIONS.GET_LOT_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}?${Vue.helpers.getQueryParamsString()}`
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.GET_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_MANAGEMENT.MUTATIONS.GET_LOT_INFO, resp.data)
  },
  async [LOT_MANAGEMENT.ACTIONS.CREATE_LOT_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}`,
      model: model.lot
    }
    const resp = await dispatch(AXIOS_REQUESTS.ACTIONS.POST_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
    commit(LOT_MANAGEMENT.MUTATIONS.GET_LOT_INFO, resp.data)
  },
  async [LOT_MANAGEMENT.ACTIONS.UPDATE_LOT_INFO] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}`,
      model: model.lot
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.PUT_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_MANAGEMENT.ACTIONS.DELETE_LOT] ({ dispatch, commit }, model) {
    model = {
      url: `${Vue.getBusinessHost()}${URL_LOTS}/${model.lotType}/${model.lotId}`
    }
    await dispatch(AXIOS_REQUESTS.ACTIONS.DELETE_AXIOS_REQUEST, model, { root: true })
    commit(ERRORS.MUTATIONS.ERROR_CLEAR, null, { root: true })
  },
  async [LOT_MANAGEMENT.ACTIONS.CLEAR_LOT_INFO] ({ commit }) {
    commit(LOT_MANAGEMENT.MUTATIONS.CLEAR_LOT_INFO)
  }
}

const mutations = {
  [LOT_MANAGEMENT.MUTATIONS.GET_LOT_INFO] (state, lot) {
    state[LOT_MANAGEMENT.STATE.CURRENT_LOT] = lot
  },
  [LOT_MANAGEMENT.MUTATIONS.CLEAR_LOT_INFO] (state) {
    state[LOT_MANAGEMENT.STATE.CURRENT_LOT] = null
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
